import { PutObjectCommand } from "@aws-sdk/client-s3";
import s3 from "./digitalocean-aws-s3-config";

const uploadDocument = async (path, file) => {
  const params = {
    Bucket: process.env.VUE_APP_STORAGE_BUCKET,
    Key: `${path}`,
    Body: file,
  };
  try {
    await s3.send(new PutObjectCommand(params));
    return true;
  } catch (err) {
    console.log("Error", err);
    return false;
  }
};

export default uploadDocument;
